<script setup lang="ts">
import { useUsersStore } from "~/stores/users";

const usersStore = useUsersStore();

await useAsyncData("/users/me", () => usersStore.getMe());
</script>

<template>
	<main class="min-w-screen h-screen">
		<slot></slot>
	</main>
</template>
